import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CreateOrganizationBlackListExceptionForOrganizationCommand } from 'src/app/core/api/models';

import { OrganizationBlackListExceptionsService } from 'src/app/core/api/services';
import { NumberSeparatorPipe } from 'src/app/core/pipes/number.separator.pipe';
import { BaseFormPageComponent } from 'src/app/pages/shared/base';
import { BaseFormModule } from 'src/app/shared/components/base/base-component/base-form.module';
import { ModalTitleComponent } from 'src/app/shared/global/modal-title/modal-title.component';

@Component({
    selector: 'app-organizations-black-list-exceptions-form',
    templateUrl: './organizations-black-list-exceptions-form.component.html',
    imports: [BaseFormModule, ModalTitleComponent],
    providers: [NumberSeparatorPipe]
})
export class OrganizationsBlackListExceptionsFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties
  model: CreateOrganizationBlackListExceptionForOrganizationCommand = {};
  mobiles: string[] = [];
  //#endregion

  constructor(
    protected currentService: OrganizationBlackListExceptionsService,
    private dialogRef: MatDialogRef<OrganizationsBlackListExceptionsFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.formPageConfig.title = data?.title;
    this.formPageConfig.isEditMode = data?.isEdit;
    this.model.organizationId = data?.organizationId;
  }

  ngOnInit() {
    this.initForm();
  }

  ngAfterViewChecked(): void {
    this.cd.detectChanges();
  }

  initForm() {
    this.form = new FormGroup({
      mobiles: new FormControl('', Validators.required),
    });
  }

  getMobiles(numbers) {
    const numbersArray = numbers
      .split(',')
      .map((item) => item.trim())
      .filter((item) => item !== '');

    this.model.mobiles = numbersArray;
  }

  //#region Api

  //Create
  baseCreateApi(
    model: CreateOrganizationBlackListExceptionForOrganizationCommand
  ) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .organizationBlackListExceptionsCreate({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  //#region final methods

  onClose() {
    this.dialogRef.close(false);
  }

  onSuccess() {
    this.dialogRef.close(true);
    this.unSubs();
  }

  //#endregion
}
